<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      enable-resize-watcher
      fixed
      app
      class="grey darken-4"
    >
      <side-drawer></side-drawer>
    </v-navigation-drawer>
    <v-toolbar
      app
      color="primary"
      class="elevation-1"
    >
      <v-btn icon @click="goBack()">
        <v-icon>keyboard_arrow_left</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-toolbar-title class="white--text">Transaction List</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-content>
      <v-container grid-list-lg>
        <v-layout fluid wrap>
          <v-flex xs12>
            <v-layout align-center pb-4>
              <v-flex text-xs-center >
                <div v-if="user" class="headline font-weight-medium text-center pl-3 pr-3 pt-3">{{ user.loginEmail }}<span v-if="user.storeCurrencyCode"> ({{ user.storeCurrencyCode }})</span></div>
                <div v-if="user" class="body-2 font-weight-bold text-center pl-3 pr-3">Level: {{ user.type | allCaps }}</div>
              </v-flex>
            </v-layout>
          </v-flex>
          <!-- <v-flex xs4 md5>
            <v-menu
              ref="menu1"
              :close-on-content-click="false"
              v-model="dtPicker1"
              :nudge-right="40"
              :return-value.sync="date1"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <v-text-field
                slot="activator"
                v-model="date1"
                label="Date from"
                prepend-icon="event"
                readonly
              ></v-text-field>
              <v-date-picker v-model="date1" no-title scrollable @input="$refs.menu1.save(date1)"></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs4 md5>
            <v-menu
              ref="menu2"
              :close-on-content-click="false"
              v-model="dtPicker2"
              :nudge-right="40"
              :return-value.sync="date2"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <v-text-field
                slot="activator"
                v-model="date2"
                label="Date to"
                prepend-icon="event"
                readonly
              ></v-text-field>
              <v-date-picker v-model="date2" no-title scrollable @input="$refs.menu2.save(date2)"></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs4 md2>
            <v-btn block
            >
              Filter
            </v-btn>
          </v-flex> -->
          <v-flex xs12 class="text-xs-center">
            <v-data-table
              :items="transactions"
              hide-actions
              class="elevation-1"
            >
              <template slot="headers">
                <tr>
                  <th class="text-xs-center subheading font-weight-bold">
                    Date
                  </th>
                  <th class="text-xs-left subheading font-weight-bold">
                    Details
                  </th>
                  <th class="text-xs-right hidden-xs-only subheading font-weight-bold">
                    Debit
                  </th>
                  <th class="text-xs-right hidden-xs-only subheading font-weight-bold">
                    Credit
                  </th>
                  <th class="text-xs-right hidden-xs-only subheading font-weight-bold">
                    Balance
                  </th>
                  <th class="text-xs-right hidden-sm-and-up subheading font-weight-bold">
                    Amount
                  </th>
                </tr>
              </template>
              <template slot="items" slot-scope="props">
                <tr
                :class="(props.index % 2 === 0 ? 'row1' : 'row2')"
                >
                  <td class="text-xs-center">{{ props.item.createdDateTime | formatDate('DD MMMM YYYY HH:mm', profile.gmtTimezone) }}</td>
                  <td class="text-xs-left pt-2 pb-2">
                    <div>
                      <router-link v-if="props.item.url" :to="props.item.url" class="white--text">{{ props.item.details }}</router-link>
                      <span v-else>{{ props.item.details }}</span>
                      <v-btn v-if="props.item.transactionId === 'TRX-SUMMARY'" small outline class="ml-3" @click="loadFullTransactionList()">View</v-btn>
                      <v-icon v-else class="ml-3" @click="openEditTransactionDialog(props.item.transactionId)">edit</v-icon>
                    </div>
                    <div v-if="props.item.updatedByAdminName" class="caption ont-weight-thin">
                      Updated by {{ props.item.updatedByAdminName }} on {{ props.item.updatedDateTime | formatDate('DD MMMM YYYY HH:mm', profile.gmtTimezone) }}
                    </div>
                    <div v-else-if="props.item.createdByAdminName" class="caption font-weight-thin">
                      By {{ props.item.createdByAdminName }} on {{ props.item.createdDateTime | formatDate('DD MMMM YYYY HH:mm', profile.gmtTimezone) }}
                    </div>
                  </td>
                  <td class="text-xs-right hidden-xs-only">
                    <div v-if="props.item.debit > 0">{{ def.currency.sign + formatPrice(props.item.debit, def.currency.decimals, def.currency.decimalSign) }}</div>
                    <div v-if="props.item.debit > 0 && props.item.exchangeRateToBase !== 1" class="caption grey--text">{{ props.item.currencySign + formatPrice(props.item.amount, props.item.currencyDecimals, props.item.currencyDecimalSign) }}</div>
                    <div v-if="props.item.debit > 0 && props.item.storeCurrencyCode && props.item.storeCurrencyCode !== def.currency.currencyCode && props.item.storeCurrencyCode !== props.item.currencyCode" class="caption grey--text">{{ props.item.storeCurrencySign + formatPrice(props.item.amountInBase / props.item.exchangeRateFromStoreCurrencyToBase, props.item.storeCurrencyDecimals, props.item.storeCurrencyDecimalSign) }}</div>
                    <div v-if="props.item.debit > 0 && props.item.paymentFeeAmountInBase < 0" class="caption orange--text">Discount ${{ formatPrice(Math.abs(props.item.paymentFeeAmountInBase)) }}</div>
                  </td>
                  <td class="text-xs-right hidden-xs-only">
                    <div v-if="props.item.credit > 0">{{ def.currency.sign + formatPrice(props.item.credit, def.currency.decimals, def.currency.decimalSign) }}</div>
                    <div v-if="props.item.credit > 0 && props.item.exchangeRateToBase !== 1" class="caption grey--text">{{ props.item.currencySign + formatPrice(props.item.amount, props.item.currencyDecimals, props.item.currencyDecimalSign) }}</div>
                    <div v-if="props.item.credit > 0 && props.item.storeCurrencyCode && props.item.storeCurrencyCode !== def.currency.currencyCode && props.item.storeCurrencyCode !== props.item.currencyCode" class="caption grey--text">{{ props.item.storeCurrencySign + formatPrice(props.item.amountInBase / props.item.exchangeRateFromStoreCurrencyToBase, props.item.storeCurrencyDecimals, props.item.storeCurrencyDecimalSign) }}</div>
                    <div v-if="props.item.credit > 0 && props.item.paymentFeeAmountInBase < 0" class="caption orange--text">Discount ${{ formatPrice(Math.abs(props.item.paymentFeeAmountInBase)) }}</div>
                  </td>
                  <td class="text-xs-right hidden-xs-only">{{ def.currency.sign + formatPrice(props.item.balance) }}</td>
                  <td class="text-xs-right hidden-sm-and-up font-weight-bold">{{ def.currency.sign + (props.item.type === 'debit' ? '-' : '') + formatPrice(props.item.amountInBase) }}</td>
                </tr>
              </template>
              <template slot="footer">
                <td colspan="2" class="hidden-xs-only"></td>
                <td class="text-xs-right hidden-xs-only">
                  {{ def.currency.sign }}{{ formatPrice(totalDebit) }}
                </td>
                <td class="text-xs-right hidden-xs-only">
                  {{ def.currency.sign }}{{ formatPrice(totalCredit) }}
                </td>
                <td class="text-xs-right title font-weight-bold hidden-xs-only">
                  <strong>{{ def.currency.sign }}{{ formatPrice(totalBalance) }}</strong>
                </td>
                <td colspan="6" class="text-xs-right title font-weight-bold hidden-sm-and-up">
                  <strong>{{ def.currency.sign }}{{ formatPrice(totalBalance) }}</strong>
                </td>
              </template>
            </v-data-table>
          </v-flex>
          <v-flex x12 class="text-xs-left">
            <v-btn
              outline
              class="mt-3"
              v-if="isAccessCreateTransaction"
              @click="showAddTransaction()"
            >
              <v-icon left class="notranslate">add</v-icon>
              Add Transaction
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
      <v-dialog v-model="dialogAddTransaction" max-width="600px">
        <v-card>
          <v-card-title>
            <h3 class="title font-weight-bold">Add Transaction</h3>
          </v-card-title>
          <v-card-text>
            <v-form ref="frmAddTransaction" v-model="frmAddTransactionValid" @submit.prevent="">
              <v-container grid-list-lg>
                <v-layout fluid wrap>
                  <v-flex xs12>
                    <v-select
                      v-model="cboTransType"
                      :items="types"
                      :rules="[v => !!v || 'Please select type']"
                      label="Type"
                      required
                    ></v-select>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      label="Details"
                      v-model="txtTransDetails"
                      :rules="[v => !!v || 'Details is required', v => (v && v.length >= 3) || 'Details must be 3 characters or more']"
                      :counter=50
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs3>
                    <v-select
                      v-model="cboCurrencyCode"
                      :rules="[v => !!v || 'Please choose currency']"
                      :items="currencies"
                      item-text="currencyCode"
                      item-value="currencyCode"
                      label="Currency"
                      @change="clickCurrency($event)"
                      required
                    ></v-select>
                  </v-flex>
                  <v-flex xs9>
                    <v-text-field
                      v-model="txtTransAmount"
                      :rules="[v => v > 0 || 'Amount must be more than 0']"
                      label="Amount"
                      type="number"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      v-model="txtExchangeRateToBase"
                      :rules="[v => v > 0 || 'Exchange rate must be more than 0']"
                      label="Exchange Rate to USD"
                      type="number"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-btn
                      :disabled="!frmAddTransactionValid"
                      @click="submitAddTransaction()"
                    >
                      Add Transaction
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogEditTransaction" max-width="600">
        <v-card>
          <v-card-title class="headline">
            Edit Transaction
          </v-card-title>
          <v-card-text>
            <v-form ref="formEditTransaction" v-model="frmEditTransactionValid" @submit.prevent="">
              <v-container grid-list-lg class="pa-0">
                <v-layout fluid wrap>
                  <v-flex xs12>
                    <v-text-field
                      label="Details"
                      v-model="txtTransactionNewDetails"
                      :rules="[v => !!v || 'Details is required', v => (v && v.length >= 3) || 'Details must be 3 characters or more']"
                      @keyup.enter="(frmEditTransactionValid ? editTransaction(dialogTransactionId, txtTransactionNewDetails, txtExchangeRateToBase) : '')"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs3>
                    <v-select
                      v-model="cboCurrencyCode"
                      :rules="[v => !!v || 'Please choose currency']"
                      :items="currencies"
                      item-text="currencyCode"
                      item-value="currencyCode"
                      label="Currency"
                      disabled
                      required
                    ></v-select>
                  </v-flex>
                  <v-flex xs9>
                    <v-text-field
                      v-model="txtTransAmount"
                      :rules="[v => v > 0 || 'Amount must be more than 0']"
                      label="Amount"
                      type="number"
                      disabled
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      v-model="txtExchangeRateToBase"
                      :rules="[v => v > 0 || 'Exchange rate must be more than 0']"
                      label="Exchange Rate to USD"
                      type="number"
                      @keyup.enter="(frmEditTransactionValid ? editTransaction(dialogTransactionId, txtTransactionNewDetails, txtExchangeRateToBase) : '')"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6>
                    <v-btn
                      :disabled="!frmEditTransactionValid"
                      @click="editTransaction(dialogTransactionId, txtTransactionNewDetails, txtExchangeRateToBase)"
                    >
                      Save
                    </v-btn>
                  </v-flex>
                  <v-flex xs6 class="text-xs-right">
                    <!--<v-progress-circular
                      v-if="loadingTransaction"
                      indeterminate
                      color="white"
                      :width=3
                      class="mt-1 mr-3"
                    ></v-progress-circular>
                    <v-icon v-if="transactionDetails && transactionDetails.isLinked === '0'" class="mt-2 mr-3" @click="openDeleteCategoryDialog(dialogTransactionId)">delete</v-icon>-->
                    <v-icon class="mt-2 mr-3" @click="openDeleteCategoryDialog(dialogTransactionId)">delete</v-icon>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogDeleteTransaction" max-width="350">
        <v-card>
          <v-card-title class="headline">Confirmation</v-card-title>

          <v-card-text>
            Are you sure to delete this transaction?
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              color="secondary"
              class="grey--text"
              @click="dialogDeleteTransaction = false"
            >
              Cancel
            </v-btn>

            <v-btn
              color="primary"
              @click="dialogDeleteTransaction = false; deleteTransaction(dialogTransactionId);"
            >
              Delete
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="loading"
        hide-overlay
        persistent
        width="220"
      >
        <loading></loading>
      </v-dialog>
    </v-content>
  </div>
</template>

<style scoped>
form {
  width: 100%;
}
</style>

<script>
import SideDrawer from '@/components/SideDrawer.vue'
import Loading from '@/components/Loading.vue'
import router from '../router'
import axios from 'axios'

export default {
  props: [
    'userId'
  ],
  components: {
    SideDrawer,
    Loading
  },
  data () {
    return {
      profile: this.$store.getters.getProfile,
      def: this.$store.getters.getDef,
      user: null,
      drawer: false,
      loading: false,
      loadingTransaction: false,
      showFullList: false,
      transactionDetails: {},
      date1: null,
      date2: null,
      dtPicker1: false,
      dtPicker2: false,
      currencies: [],
      transactions: [],
      totalDebit: 0,
      totalCredit: 0,
      totalBalance: 0,
      dialogAddTransaction: false,
      frmAddTransactionValid: false,
      types: ['debit', 'credit'],
      cboTransType: '',
      txtTransDetails: '',
      cboCurrencyCode: 'USD',
      txtTransAmount: 0,
      txtExchangeRateToBase: 1,
      dialogTransactionId: null,
      dialogEditTransaction: false,
      frmEditTransactionValid: false,
      txtTransactionNewDetails: '',
      dialogDeleteTransaction: false,
      isAccessCreateTransaction: false
    }
  },

  mounted () {
    this.openDrawerForDesktop()
    this.getUser()
    this.getCurrencies()
    this.disableBottomDetector()

    if (typeof this.profile.permissions !== 'undefined') {
      for (var i in this.profile.permissions) {
        if (this.profile.permissions[i].permissionId === 'PEM-TRANSACTION' && this.profile.permissions[i].isCreate === '1') {
          this.isAccessCreateTransaction = true
        }
      }
    }
  },

  methods: {
    clickCurrency: function (currencyCode) {
      for (var i in this.currencies) {
        if (this.currencies[i].currencyCode === currencyCode) {
          this.txtExchangeRateToBase = this.currencies[i].exchangeRateToBase
          break
        }
      }
    },
    getCurrencies: function () {
      var _this = this
      _this.loading = true
      axios.get(process.env.VUE_APP_API_ROOT + '/v1/currencies')
        .then(resp => {
          console.log(resp.data)
          _this.loading = false
          if (resp.data.status === 'success') {
            _this.currencies = resp.data.data
          } else {
            console.log('unable to load currencies: ' + resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + _this.$route.fullPath)
            } else if (error.response.status === 403) {
              _this.showAlert(error)
            }
            _this.loading = false
          }
        })
    },
    showAddTransaction: function () {
      this.txtTransDetails = ''
      this.cboTransType = ''
      this.cboCurrencyCode = 'USD'
      this.txtExchangeRateToBase = 1
      this.txtTransAmount = 0
      this.dialogAddTransaction = true
    },
    submitAddTransaction: function () {
      if (this.userId) {
        this.loading = true
        axios.post(process.env.VUE_APP_API_ROOT + '/v1/transaction', {
          userId: this.userId,
          details: this.txtTransDetails,
          type: this.cboTransType,
          currencyCode: this.cboCurrencyCode,
          exchangeRateToBase: this.txtExchangeRateToBase,
          amount: this.txtTransAmount
        }, {
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(resp => {
            console.log(resp.data)
            this.loading = false
            if (resp.data.status === 'success') {
              this.dialogAddTransaction = false
              this.getTransactions()
            } else {
              window.alert(resp.data.message)
            }
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.status)
              if (error.response.status === 401) {
                router.push('/login?next=' + this.$route.fullPath)
              } else if (error.response.status === 403) {
                this.showAlert(error)
              }
              this.loading = false
            }
          })
      }
    },
    getUser: function () {
      var _this = this
      var promise = new Promise(function (resolve, reject) {
        _this.loading = true
        axios.get(process.env.VUE_APP_API_ROOT + '/v1/user/' + _this.userId)
          .then(resp => {
            _this.loading = false
            console.log(resp.data)
            if (resp.data.status === 'success') {
              _this.user = resp.data.data
              _this.getTransactions()
            } else {
              console.log('unable to load user details: ' + resp.data.message)
            }
            resolve()
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.status)
              if (error.response.status === 401) {
                router.push('/login?next=' + _this.$route.fullPath)
                reject(error.response.status)
              } else if (error.response.status === 403) {
                _this.showAlert(error)
                reject(error.response.status)
              }
              _this.loading = false
            }
          })
      })
      return promise
    },
    getTransaction: function (transactionId) {
      var _this = this
      var promise = new Promise(function (resolve, reject) {
        _this.loading = true
        axios.get(process.env.VUE_APP_API_ROOT + '/v1/transaction/' + transactionId)
          .then(resp => {
            _this.loading = false
            console.log(resp.data)
            if (resp.data.status === 'success') {
              _this.transactionDetails = resp.data.data
            } else {
              console.log('unable to load transaction: ' + resp.data.message)
            }
            resolve()
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.status)
              if (error.response.status === 401) {
                router.push('/login?next=' + _this.$route.fullPath)
                reject(error.response.status)
              } else if (error.response.status === 403) {
                _this.showAlert(error)
                reject(error.response.status)
              }
              _this.loading = false
            }
          })
      })
      return promise
    },
    openEditTransactionDialog: function (transactionId) {
      this.dialogTransactionId = transactionId
      for (var i in this.transactions) {
        if (this.transactions[i].transactionId === transactionId) {
          this.txtTransactionNewDetails = this.transactions[i].details
          this.txtExchangeRateToBase = this.transactions[i].exchangeRateToBase
          this.cboCurrencyCode = this.transactions[i].currencyCode
          this.txtTransAmount = this.transactions[i].amount
          break
        }
      }
      this.dialogEditTransaction = true
      // this.getTransaction(this.dialogTransactionId)
    },
    editTransaction: function (transactionId, transactionNewDetails, newRate) {
      var _this = this
      if (transactionNewDetails && transactionNewDetails.length > 0 && newRate > 0) {
        _this.dialogEditCategory = false
        _this.loading = true
        axios.put(process.env.VUE_APP_API_ROOT + '/v1/transaction/' + transactionId, {
          details: transactionNewDetails,
          exchangeRateToBase: newRate
        }, {
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(resp => {
            _this.loading = false
            console.log(resp.data)
            if (resp.data.status === 'success') {
              _this.dialogEditTransaction = false
              _this.refreshList()
            } else {
              window.alert(resp.data.message)
            }
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.status)
              if (error.response.status === 401) {
                router.push('/login?next=' + _this.$route.fullPath)
              } else if (error.response.status === 403) {
                _this.showAlert(error)
              }
              _this.loading = false
            }
          })
      }
    },
    openDeleteCategoryDialog: function (transactionId) {
      this.dialogTransactionId = transactionId
      this.dialogEditTransaction = false
      this.dialogDeleteTransaction = true
    },
    deleteTransaction: function (transactionId) {
      var _this = this
      _this.dialogDeleteTransaction = false
      _this.loading = true
      axios.delete(process.env.VUE_APP_API_ROOT + '/v1/transaction/' + transactionId)
        .then(resp => {
          _this.loading = false
          console.log(resp.data)
          if (resp.data.status === 'success') {
            _this.dialogDeleteTransaction = false
            _this.refreshList()
          } else {
            window.alert(resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + _this.$route.fullPath)
            } else if (error.response.status === 403) {
              _this.showAlert(error)
            }
            _this.loading = false
          }
        })
    },
    refreshList: function () {
      this.items = []
      var _this = this
      return new Promise(function (resolve, reject) {
        var promise = _this.getTransactions()
        promise.then(function () {
          resolve()
        })
      })
    },
    loadFullTransactionList: function () {
      this.showFullList = true
      this.getTransactions()
    },
    getTransactions: function () {
      var _this = this
      var promise = new Promise(function (resolve, reject) {
        _this.loading = true
        var url = process.env.VUE_APP_API_ROOT + '/v1/user/' + _this.userId + '/transactions'
        if (_this.showFullList) {
          url += '?full-list=1'
        }
        axios.get(url)
          .then(resp => {
            console.log(resp.data)
            if (resp.data.status === 'success') {
              var balance = 0
              var totalCredit = 0
              var totalDebit = 0
              for (var i = 0; i < resp.data.data.length; i++) {
                resp.data.data[i].debit = 0
                resp.data.data[i].credit = 0
                if (resp.data.data[i].type === 'debit') {
                  balance = balance - resp.data.data[i].amountInBase
                  resp.data.data[i].credit = resp.data.data[i].amountInBase
                  totalCredit += resp.data.data[i].amountInBase
                } else {
                  balance = balance + resp.data.data[i].amountInBase
                  resp.data.data[i].debit = resp.data.data[i].amountInBase
                  totalDebit += resp.data.data[i].amountInBase
                }
                resp.data.data[i].balance = balance
                resp.data.data[i].url = ''
                if (resp.data.data[i].forSalesOrderNo.length > 0) {
                  resp.data.data[i].url = '/order/' + resp.data.data[i].forSalesOrderNo
                } else if (resp.data.data[i].forPaymentId.length > 0) {
                  resp.data.data[i].url = '/payment/' + resp.data.data[i].forPaymentId
                }
              }
              _this.transactions = resp.data.data
              _this.totalBalance = balance
              _this.totalCredit = totalCredit
              _this.totalDebit = totalDebit
              _this.loading = false
            } else {
              console.log('unable to load transactions: ' + resp.data.message)
            }
            resolve()
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.status)
              if (error.response.status === 401) {
                router.push('/login?next=' + _this.$route.fullPath)
                reject(error.response.status)
              } else if (error.response.status === 403) {
                _this.showAlert(error)
                reject(error.response.status)
              }
              _this.loading = false
            }
          })
      })
      return promise
    }
  }
}
</script>
